var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconeCpf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 84,
    viewBox: "0 0 78 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9359 81.9988V63.1941",
    stroke: "#4C4C4C",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6531 81.9995L38.6531 56.8203",
    stroke: "#F59B1B",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.37 81.9988V63.1941",
    stroke: "#4C4C4C",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6249 81.9999V61.8788C75.6249 56.4827 71.7746 51.7268 66.4576 50.5378L49.1315 46.7879L48.2147 39.9285",
    stroke: "#4C4C4C",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 81.9999V61.8788C2 56.4827 5.85026 51.7268 11.1673 50.5378L28.4935 46.7879L29.4102 39.9285",
    stroke: "#4C4C4C",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8124 44.7089C38.0736 44.7089 37.2425 44.6171 36.5037 44.4334C35.1185 44.066 34.1027 43.6986 32.2557 42.4127C30.5011 41.1269 28.8388 39.1981 28.8388 39.1981C27.7307 37.9122 26.7148 36.4427 25.7913 34.7894C25.0526 33.5036 24.4985 32.2177 23.9444 30.84L23.575 29.8297L22.4668 29.646C22.1898 29.5541 21.6357 29.2786 21.6357 29.2786C21.6357 29.2786 21.174 28.9112 21.0816 28.6357C21.0816 28.6357 20.8046 27.9927 20.8046 27.6254V21.2879C20.8046 20.7368 20.9893 20.0939 21.2663 19.5428C21.3587 19.2673 21.5433 19.0836 21.728 18.8999L22.2821 18.1651V17.3385C22.2821 8.88854 29.2082 2 37.7042 2H38.9048H40.1053C48.6013 2 55.5274 8.88854 55.5274 17.3385V18.1651L55.8968 18.8999C56.0815 19.0836 56.1738 19.2673 56.3585 19.5428C56.6356 20.0939 56.8203 20.645 56.8203 21.2879V27.6254C56.8203 27.9927 56.5432 28.6357 56.5432 28.6357C56.3585 29.0031 55.9891 29.2786 55.9891 29.2786C55.9891 29.2786 55.435 29.5541 55.158 29.646L54.0498 29.8297L53.6804 30.84C53.1264 32.1259 52.5723 33.5036 51.8335 34.7894C50.91 36.4427 49.8942 37.9122 48.786 39.1981C48.786 39.1981 47.1237 41.1269 45.3691 42.4127C43.6145 43.6986 42.5987 44.066 41.1211 44.4334C40.29 44.6171 39.5512 44.7089 38.8124 44.7089Z",
    stroke: "#4C4C4C",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0311 47.4318C27.0311 47.4318 29.9596 58.9626 30.6002 60.0608C32.339 59.5117 36.7316 57.7729 38.8365 56.6747C31.1493 52.5566 27.3057 47.9808 27.0311 47.4318Z",
    stroke: "#F59B1B",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5495 47.4321C50.5495 47.4321 47.621 58.963 46.9804 60.0611C45.2417 59.512 40.849 57.7733 38.7441 56.6751C46.4313 52.5569 50.275 47.9812 50.5495 47.4321Z",
    stroke: "#F59B1B",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeCpf);
export default __webpack_public_path__ + "static/media/icone_cpf.7c090a94f2835602c7f07ebab76a85da.svg";
export { ForwardRef as ReactComponent };